import { render } from "./QbeekLogoSmall.vue?vue&type=template&id=7b5acaa0"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/QbeekLogoSmall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b5acaa0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b5acaa0', __exports__)) {
    api.reload('7b5acaa0', __exports__)
  }
  
  module.hot.accept("./QbeekLogoSmall.vue?vue&type=template&id=7b5acaa0", () => {
    api.rerender('7b5acaa0', render)
  })

}


export default __exports__